import * as React from 'react';
import S from './Form.styles';
const ErrorSummary = (props) => {
    return (React.createElement(S.ErrorList, { ...props.variants }, props.errors.map((error, i) => (React.createElement(S.ErrorListItem, { key: `error-${i}`, dangerouslySetInnerHTML: { __html: `<span>!</span> <div>${error}</div>` } })))));
};
export default ErrorSummary;
